@let aptitude = aptitudeForm.value;
@if (aptitude) {
  <form [formGroup]="form()">
    <app-expansion-panel [titre]="aptitude.nom" [item]="aptitude" [isOpen]="true" [actions]="actionAptitude">
      <div class="m-md gap-md grid">
        <app-expansion-panel [item]="aptitude" titre="Interrelations">
          <div class="flex flex-col">
            @for (
              interrelation of getInterrelationsFromAptitude(aptitude);
              track interrelation.id;
              let idx = $index;
              let last = $last
            ) {
              <app-checkbox-submenu-item [item]="interrelation" [formcontrol]="interrelations" />

              @if (!last) {
                <div hlmItemSeparator></div>
              }
            } @empty {
              <span class="py-md px-lg text-content-secondary paragraph-medium-medium"
                >Pas d'interrelation associée à la phase de cette aptitude.</span
              >
            }
          </div>
        </app-expansion-panel>

        <app-expansion-panel [item]="aptitude" titre="Productions">
          <div class="flex flex-col">
            @for (production of getProductionsFromAptitude(aptitude); track production.id; let last = $last) {
              <app-checkbox-submenu-item [item]="production" [formcontrol]="productions">
                <button
                  class="invisible group-hover/item:visible"
                  (click)="redirectToRessourcesPro(); $event.stopPropagation()"
                  hlmBtn
                  size="compact"
                  variant="ghost"
                  hlmTooltipTrigger="Voir les ressources professionnelles"
                >
                  <ng-icon hlm size="sm" name="lucideEye" />
                </button>
              </app-checkbox-submenu-item>

              @if (!last) {
                <div hlmItemSeparator></div>
              }
            } @empty {
              <span class="py-md px-lg text-content-secondary paragraph-medium-medium"
                >Pas de production associée à cette aptitude.</span
              >
            }
          </div>
        </app-expansion-panel>

        <div class="gap-xs flex flex-col">
          <label
            [class]="{
              'text-components-content-neutral-quaternary': form().disabled,
            }"
            [for]="'radio-group-eval-' + index()"
            hlmFieldLabel
            labelRequired
            >Évaluation de l'aptitude</label
          >
          <hlm-radio-group class="flex flex-col" formControlName="estEvaluee">
            <hlm-radio [id]="'radio-oui-eval-' + index()" [value]="true"
              ><hlm-radio-indicator indicator />
              <label class="flex items-center" [for]="'radio-oui-eval-' + index()"> Oui, l'aptitude est évaluée</label>
            </hlm-radio>
            <hlm-radio [id]="'radio-non-eval-' + index()" [value]="false"
              ><hlm-radio-indicator indicator />
              <label class="flex items-center" [for]="'radio-non-eval-' + index()"
                >Non, l'aptitude n'est pas évaluée</label
              >
            </hlm-radio>
          </hlm-radio-group>

          @if (estEvaluee.value) {
            <div hlmField>
              <label [for]="'objectif-pedagogique' + index()" hlmFieldLabel labelRequired>Objectif pédagogique</label>
              <input [id]="'objectif-pedagogique' + index()" hlmInput type="text" formControlName="objectif" />
            </div>
          }
        </div>
      </div>
    </app-expansion-panel>
  </form>
}
